import { Vue, Component } from 'vue-property-decorator'
import Img from '~/types/api/Img'
import ImageElement from '~/components/element/ImageElement'
import s from '~/utils/s'

@Component
export default class SeoTextBlock extends Vue {
  isShowMoreText: boolean = false
  seoText: string = ''
  img: Img = {
    d: '',
    t: '',
    m: ''
  }

  mounted () {
    this.seoText = s(this.$store).seoTextBlock.seoTextBlock.text
    this.img = s(this.$store).seoTextBlock.seoTextBlock.img
  }

  isFillSeoData () {
    return this.seoText !== '' && this.img !== undefined
  }

  isShowToggle () {
    return this.seoText ? this.seoText.length > 970 : false
  }

  showMore () {
    this.isShowMoreText = !this.isShowMoreText
  }

  render () {
    if (this.isFillSeoData()) {
      return (
        <div class="seo-text-block">
          <div class="seo-text-block__content">
            <div class="seo-text-block__row">
              <div class="seo-text-block__col-image">
                <div class="seo-text-block__image">
                  <ImageElement {...{
                    props: {
                      img: this.img
                    }
                  }} />
                </div>
              </div>
              <div class="seo-text-block__col-content">
                <div class={{
                  'seo-text-block__text': true,
                  'seo-text-block__text-more': this.isShowMoreText
                }}
                domPropsInnerHTML={this.seoText}>
                </div>
                {this.isShowToggle() &&
                  <div class="seo-text-block__toggle-show-more" onClick={() => this.isShowMoreText = !this.isShowMoreText}>
                    {this.isShowMoreText ? 'Скрыть' : 'Показать все'}
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      )
    }
  }
}
